/* @flow */

type NamespacedActionsT = {
  [string]: string,
};

const DEFAULT_PREFIX = 'sdrenewables@@';

/**
 * Adds specified namspace to every action name in passed list
 */
export default function namespaceActions(
  namespace: string,
  names: Array<string>,
  prefix: string = DEFAULT_PREFIX
): NamespacedActionsT {
  return names.reduce((acc, name) => {
    acc[name] = `${prefix}${namespace}/${name}`;
    return acc;
  }, {});
}
